import React from "react";
import ReactMarkdown from "react-markdown";
import moment from "moment";

export interface SessionInfoTabProps {
  title: string;
  description: string;
  timeStart: Date;
  timeEnd: Date;
}

const SessionInfoTab = ({
  title,
  description,
  timeStart,
  timeEnd,
}: SessionInfoTabProps) => {
  return (
    <div className="relative w-full h-full">
      <div
        className="w-full h-full"
        style={{
          minHeight: "300px",
        }}
      >
        <div className="absolute top-0 left-0 w-full h-full overflow-y-scroll">
          <div className="space-y-4">
            <div className="text-3xl font-medium leading-none">{title}</div>
            <div className="text-sm">
              {moment(timeStart).format("H:mm")} -{" "}
              {moment(timeEnd).format("H:mm")}
            </div>
            {description ? (
              <div className="space-y-4 leading-relaxed text-gray-400">
                <ReactMarkdown source={description.replace(/\\n/g, "\n")} />
              </div>
            ) : (
              <div className="w-full p-4 text-sm text-center text-gray-400 bg-gray-200 rounded">
                No description.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SessionInfoTab;
